import * as actionTypes from '../../actions/actionTypes';

export const initialState = {
  globalLoading: false,
  globalError: '',
  bugsnag: null,
  timestamps: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.app.SET_GLOBAL_ERROR:
      return {
        ...state,
        globalLoading: false,
        globalError: action.error
      };
    case actionTypes.app.SET_GLOBAL_LOADING:
      return {
        ...state,
        globalLoading: action.loading,
        globalError: ''
      };
    case actionTypes.app.SET_BUGSNAG_CLIENT:
      return {
        ...state,
        bugsnag: action.client
      };
    case actionTypes.app.SET_RESYNC_TIMESTAMP:
      return {
        ...state,
        timestamps: {
          dars: action.darsTimestamp,
          divisions: action.divisionTimestamp,
          divisionRelations: action.divisionRelationTimestamp,
          properties: action.propertyTimestamp,
          users: action.userTimestamp
        }
      };
    default:
      return state;
  }
};

export default reducer;